import React from 'react';
import { PropTypes } from 'prop-types';
import FormGroupDefault from '../../FormGroupComponents/FormGroupDefault';

const Number = ({
  item, labelClass = '', customValues, handleCustomFieldChange,
}) => {
  return (
    <FormGroupDefault
      item={item}
      labelClass={labelClass}
      customValues={customValues}
      handleCustomFieldChange={handleCustomFieldChange}
    />
  );
};

Number.propTypes = {
  item: PropTypes.object.isRequired,
  customValues: PropTypes.object.isRequired,
  handleCustomFieldChange: PropTypes.func.isRequired,
  labelClass: PropTypes.string,
};

export default Number;
